import * as _ from 'underscore';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { IDataSourceBase } from '../models/IDataSourceInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DataSources } from '../resources/Datasources';
import { IResult } from '../ServerApi/types/IResponse';
import { IUserName } from '../ServerApi/types/IUser';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { IConfirmChangeOwnerScope } from './ContentActions';
import { DataSourceErrors } from './DataSourceErrors';
import { ModalService } from './ModalService';
import { SearchSuggestionsService } from './SearchSuggestionsService';

export class ChangeDatasourceOwnerAction {

  public static $inject = ['DataSourceErrors', 'ActionHelpers', 'ConfirmActionDialog', '$translate', 'DataSources', 'SearchSuggestionsService', 'ModalService'];

  constructor(
    private DataSourceErrors: DataSourceErrors,
    private ActionHelpers: ActionHelpers,
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private DataSources: DataSources,
    private suggestions: SearchSuggestionsService,
    private ModalService: ModalService) { }

  public confirmChangeOwner(datasources: Set<IDataSourceBase>, context: IActionContext): ng.IPromise<IResult> {

    // Disallow change owner if all selected datasources are embedded.
    if (datasources.all((ds: IDataSourceBase) => _.isObject(ds.workbook))) {
      return this.ModalService.alert({
        titleId: 'changeOwnerDatasources_cannotChangeOwnerAlertTitle',
        messageId: 'changeOwnerDatasources_cannotChangeOwnerAlertMessage'
      }).result;
    }


    const ownerPicker = {
      prompt: datasources.size() === 1
      ? this.$translate.instant('changeOwnerDatasourcePrompt', { NAME: L10n.elideIfLong(datasources.first().name) })
      : this.$translate.instant('changeOwnerDatasourcesPrompt', { COUNT: datasources.size() }, L10n.Interpolations.Count),
      ownerQuery: (matchText: string) => this.suggestions.usersWithoutGuest(matchText),
      targetOwner: <IUserName>null
    };
    const newDialogScope = <IConfirmChangeOwnerScope> context.scope.$new();
    newDialogScope.ownerPicker = ownerPicker;

    let currentOwnerId = datasources.first().owner.id;
    if(_.any(datasources.toArray(), (ds: IDataSourceBase) => (ds.owner.id !== currentOwnerId))) {
      currentOwnerId = null;
    }

    return this.ConfirmActionDialog.open({
      scope: newDialogScope,
      title: this.$translate.instant('changeOwner'),
      bodyTemplateUrl: 'changeOwnerDialog.html',
      actionName: this.$translate.instant('changeOwnerConfirm', { COUNT: datasources.size() }, L10n.Interpolations.Count),

      action: (dialogInstance: IConfirmActionDialogInstance) => {
        return this.DataSources.setOwner(datasources.keys(), ownerPicker.targetOwner.id)
          .then((result: IResult) => this.notifyResult(datasources, result, ownerPicker.targetOwner.displayName));
      },
      confirmDisabled: () => !ownerPicker.targetOwner || ownerPicker.targetOwner.id === currentOwnerId
    }).result.finally(() => newDialogScope.$destroy());
  }

  private notifyResult(datasources: Set<IDataSourceBase>, result: IResult, ownerName: string) {
    this.ActionHelpers.notifyStandardError(
      datasources,
      {
        successId: 'changeOwnerDatasourcesSuccess',
        errorId: 'changeOwnerDatasourcesError'
      },
      (errorItem: IErrorItem<IDataSourceBase>) => this.DataSourceErrors.errorDetailsFor(errorItem),
      { OWNER_NAME: ownerName }
    )(result);
  }

}

Module.instance().service('ChangeDatasourceOwnerAction', ChangeDatasourceOwnerAction);
